import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  grupo_empresa: Yup.number()
    .typeError('Selecione o Grupo de Empresa.')
    .required('Selecione o Grupo de Empresa.')
    .moreThan(0, 'Selecione o Grupo de Empresa.'),
  conta_origem: Yup.number()
    .typeError('Selecione a Conta Origem.')
    .required('Selecione a Conta Origem.')
    .moreThan(0, 'Selecione a Conta Origem.'),
  conta_destino: Yup.number()
    .typeError('Selecione a Conta Destino.')
    .required('Selecione a Conta Destino.')
    .moreThan(0, 'Selecione a Conta Destino.')
    .test(
      'contas-diferentes',
      'Conta Origem e Conta Destino não podem ser a mesma.',
      function validarContasDiferentes(value) {
        return value !== this.parent.conta_origem;
      }
    ),
});
